export default __webpack_public_path__ + "static/media/regulatory--dual-lanes-go-straight-on-left--g1.644f5631.png";